import React from 'react'
import classes from "./style.module.scss";
import CheckboxComponent from '../../../../component/CheckboxComponent';

const CreateRolePermission = (props) => {
    const { rolePermitted, setRolePermitted } = props
    const permissionHeader = [
        'Functionality', 'All', 'View', 'Edit', 'Add', 'Delete'
    ]

    const handleChange = (index, permission) => (event) => {
        const { checked } = event.target;
        setRolePermitted(prevValue =>
            prevValue.map((item, i) =>
                i === index
                    ? { ...item, [permission]: checked, all: false }
                    : item
            )
        );
    };

    const handleAllChange = (index) => (event) => {
        const { checked } = event.target;
        setRolePermitted(prevValue =>
            prevValue.map((item, i) =>
                i === index
                    ? { ...item, all: checked, view: checked, edit: checked, add: checked, delete: checked }
                    : item
            )
        );
    };

    return (
        <>
            <div className={classes.createRoleAdminWrapper}>
                <div className={`${classes.permissionRoleContainer}`}>
                    <div className='flex items-center'>
                        {permissionHeader?.map((data) =>
                            <div className={`${classes.permissionCategory} ${classes.permissionHeader}`}>{data}</div>
                        )}
                    </div>
                    <div className=''>
                        {rolePermitted?.filter((x) => x?.title !== 'Reports')?.map((item, index) =>
                            <div className={`flex items-center ${classes.borderRole}`}>
                                <div className={`${classes.permissionCategory}`}>{item?.title}</div>
                                <div className={`${classes.permissionCategory}`}>
                                    <CheckboxComponent checked={item?.all} onChange={handleAllChange(index)} />
                                </div>
                                <div className={`${classes.permissionCategory}`}>
                                    <CheckboxComponent checked={item?.view} onChange={handleChange(index, "view")} />
                                </div>
                                <div className={`${classes.permissionCategory}`}>
                                    <CheckboxComponent checked={item?.edit} onChange={handleChange(index, "edit")} />
                                </div>
                                <div className={`${classes.permissionCategory}`}>
                                    <CheckboxComponent checked={item?.add} onChange={handleChange(index, "add")} />
                                </div>
                                <div className={`${classes.permissionCategory}`}>
                                    <CheckboxComponent checked={item?.delete} onChange={handleChange(index, "delete")} />
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>

        </>
    )
}

export default CreateRolePermission